"use strict";

import "../scss/main.scss";

window.$ = window.jQuery = require("jquery");

import "bootstrap";

// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

import Panzoom from "@panzoom/panzoom";

window.designamite = {
  init: function () {
    designamite.global.init();

    designamite.cookie.init();
  },

  global: require("./methods/global"),

  cookie: require("./methods/cookie-bar"),

  setCookie: function (cname, cvalue, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },

  getCookie: function (cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
};

designamite.init();


function zoomInit() {
  if (document.querySelector('.modal-gallery')) {
    const elem = document.querySelector(
      ".modal-gallery .carousel-item.active .panzoom"
    );
    const panzoom = Panzoom(elem);
    const zoomInButton = document.getElementById("zoom-in");
    const zoomOutButton = document.getElementById("zoom-out");
    const resetButton = document.getElementById("reset");
    const parent = elem.parentElement;
    // No function bind needed
    parent.addEventListener("wheel", panzoom.zoomWithWheel);
    zoomInButton.addEventListener("click", panzoom.zoomIn);
    zoomOutButton.addEventListener("click", panzoom.zoomOut);
    resetButton.addEventListener("click", panzoom.reset);
  }
}

window.onload = zoomInit;

if (document.querySelector('.carousel.slide')) {
  var myCarousel = document.querySelector(".carousel.slide");
  myCarousel.addEventListener("slide.bs.carousel", () => {
    setTimeout(() => {
      zoomInit();
    }, 1000);
  });
}